import { Colors, presetColors } from '@client/style/Variables';
import { css } from 'styled-components';
import { findContrastingColor } from './colorContrast';

type Color = string | undefined | null;

type SimpleColorObject = { fg?: Color; bg?: Color };
export type CmsColorObject = { color?: Color; contrastColor?: Color };
export type ContainerColorProps = Color | SimpleColorObject | CmsColorObject | undefined;

const isCmsObject = (props: ContainerColorProps): props is CmsColorObject => {
	return !!props && typeof props === 'object' && 'color' in props && 'contrastColor' in props;
};
const isSimpleObject = (props: ContainerColorProps): props is SimpleColorObject => {
	return !!props && typeof props === 'object' && 'fg' in props && 'bg' in props;
};

export const containerColorCss = (
	props: ContainerColorProps,
	options: { invert?: boolean; highContrast?: boolean } = {}
) => {
	let background = Colors.lightBackground;
	let foreground: undefined | string;

	if (!props) return '';
	// console.log(props);

	// extract color props from data objects
	if (isCmsObject(props)) {
		if (props.color) background = props.color;
		if (props.contrastColor) foreground = props.contrastColor;
	} else if (isSimpleObject(props)) {
		if (props.bg) background = props.bg;
		if (props.fg) foreground = props.fg;
	} else {
		background = props;
	}

	// if there is no foreground, generate one from background contrast
	if (!foreground && background) {
		foreground = findContrastingColor(background, Colors.lightText, Colors.darkText);
	}

	// invert colors, only if they both exist
	if (options?.invert) {
		if (foreground && background) {
			const tempBg = background;
			background = foreground;
			foreground = tempBg;
		}
	}

	// for some strange buttons
	if (options?.highContrast) {
		if (background === presetColors.dust.toLowerCase()) {
			background = Colors.lightButtonBackground;
		} else if (background === presetColors.blackish.toLowerCase()) {
			foreground = Colors.lightText;
		}
	}

	return css`
		background-color: ${background};
		color: ${foreground};
	`;
};
